export function initEditModeTogglers() {
    const editTogglers = document.querySelectorAll('.spv-editToggler');
    editTogglers.forEach(editToggler => {
        editToggler.addEventListener('click', () => {
            const wrapperId = editToggler.dataset.wrapperId;
            const wrapper = wrapperId ? document.getElementById(wrapperId) : null;
            wrapper?.classList.add('spv-editMode');
            wrapper?.classList.remove('spv-viewMode');
            editToggler.classList.add('spv-screenreader');
            editToggler.setAttribute('aria-hidden', 'true');
        });
    });
}
//# sourceMappingURL=editmode-toggler.js.map